import styled from "styled-components";
import images from "../images";
import {
  DESKTOP_MEDIA_QUERY,
  HEADER_HEIGHT,
  DESKTOP_HEADER_HEIGHT
} from "../constants";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Block = styled.div`
  width: calc(50% - 2px);
  height: ${HEADER_HEIGHT}px;
  color: #fff;
  background-color: #0000ff;
  background-image: url(${({ type }) => images[type].src});
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: 15px center;
  padding-left: 45px;
  font-size: 22px;
  line-height: ${HEADER_HEIGHT}px;

  ${DESKTOP_MEDIA_QUERY} {
    width: calc(50% - 5px);
    height: ${DESKTOP_HEADER_HEIGHT}px;
    font-size: 60px;
    line-height: ${DESKTOP_HEADER_HEIGHT}px;
    padding: 0;
    text-align: center;
    background-size: 84px;
    background-position: 80px center;
  }
`;
